import React from "react";
import { UserFeedsType } from "../../types";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { GoFileMedia } from "react-icons/go";

type ProfilePhotosProps = {
  profile: UserFeedsType[] | null;
};
const ProfilePhotos: React.FC<ProfilePhotosProps> = ({ profile }) => {
  const Photos = profile?.flatMap((photo) => {
    const medias = photo.media;
    const aMedia = medias.flatMap((a) => a.imageUrl);
    return aMedia;
  });
  // console.log(Photos);

  return (
    <div className="flex w-full bg-white p-1 overflow-hidden">
      {Photos && Photos.length > 0 ? (
        <div className="grid lg:grid-cols-3 pb-5 lg:pb-0 h-full px-[2%] lg:px-0 pt-[23px] lg:pt-0 grid-cols-2 lg:bg-inherit gap-2 w-full overflow-hidden">
          {Photos &&
            Photos.map(
              (media, index) =>
                media !== null && (
                  <div
                    className="h-[199px] lg:h-[258px] shadow overflow-hidden"
                    key={index * 2}
                  >
                    <img
                      id={`imga-${index}`}
                      src={ipfsGatewayImage(media)}
                      alt={`Media ${index}`}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                )
            )}
        </div>
      ) : (
        <div className="w-full flex items-center justify-center h-32 font-Poppins text-lightBlack text-center text-3xl">
          <GoFileMedia />
          No media available
        </div>
      )}
    </div>
  );
};

export default ProfilePhotos;
